export default class LocalStorageKeys {
  static location = 'localidad'
  static token = 'token'
  static tokenComercio = 'token_comercio'
  static tokenComercioExpiracion = 'token_comercio_expira'

  static cliente = {
    dni: 'dni',
    idUser: 'iduser',
    // TODO: cambiar por "token_cliente" cuando se aplique redirección al login por falta de token
    token: 'token',
    user: 'user',
    userSb: 'usersb',
    logoCompania: 'logoCompania',
  }
}
